import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import HeartIcon from "@mui/icons-material/Favorite";
import EmptyHeartIcon from "@mui/icons-material/FavoriteBorder";
import { Box, Button, Chip, FormControlLabel, Grid, IconButton, Link, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../core/app/AppContextProvider";
import BaseTextField from "../../core/components/base/BaseTextField";
import { filterListByText } from "../../core/components/helpers/filterHelper";
import { LocationQueryAutocomplete } from "../hints/LocationAutocomplete";
import { LocationDto } from "../locations/LocationDtos";
import { OotTrickLinkDto } from "./OotTricksDtos";
import { useMutationAddOrRemoveTrickToFavortie as useMutationAddOrRemoveTrickToFavorite, useQueryOotTricks, useQueryUserFavoriteTricks } from "./OotTricksQuery";
import { getTrickDifficultyColor } from "./TrickDifficultyHelper";
const OotTricksScreen = () => {


    let navigate = useNavigate();
    let [location, setLocation] = useState<LocationDto | null>(null)
    let [searchText, setSearchText] = useState<string>("")
    let [favoriteOnly, setFavoriteOnly] = useState<boolean>(false)

    let { data: tricks } = useQueryOotTricks();

    let { data: userTricks } = useQueryUserFavoriteTricks();

    let context = useAppContext();

    context.checkTokenExpirationDate();

    tricks = tricks.filter(x => x.location?.id === location?.id || isNil(location));

    if (!isEmpty(searchText))
        tricks = filterListByText(tricks, searchText, ["location.name", "description", "name"])

    if (favoriteOnly)
        tricks = tricks.filter(x => x.links.some(y => userTricks.some(z => z.id === y.id)));

    return <Grid container spacing={2}>
        <Grid container item xs={11} spacing={2}>
            <Grid item xs={2}>
                <LocationQueryAutocomplete label="Location" additionalOnChange={(v) => setLocation(v)} selection={location} />
            </Grid>
            <Grid item xs={2}>
                <BaseTextField label="Search" onChange={(e) => setSearchText(e.currentTarget.value)} value={searchText} />
            </Grid>
            {context.isAuthenticated && <Grid item xs={2}>
                <FormControlLabel control={<Switch checked={favoriteOnly} onChange={(e, v) => setFavoriteOnly(v)} />} label="Favorite Tricks" />
            </Grid>
            }
            {context.isAuthenticated && (context.user.isAdmin || context.user.isContributor) && <Grid item xs={2}>
                <Button startIcon={<AddIcon />} sx={{ color: "green", border: "solid 1px green" }} onClick={() => navigate("/ootr/tricks/create")}>Add Trick</Button>
            </Grid>
            }
        </Grid>
        <Grid item xs={12}>
            <TableContainer className="displayContainer noScrollBarVisible" >
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell style={{ fontSize: "1.3rem" }}>Name</TableCell>
                            <TableCell style={{ fontSize: "1.3rem" }}>Description</TableCell>
                            <TableCell style={{ fontSize: "1.3rem" }}>All Links</TableCell>
                            <TableCell style={{ fontSize: "1.3rem" }}>Location</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tricks.map(trick => {
                            return <TableRow >
                                <TableCell>{context.isAuthenticated && (context.user.isAdmin || context.user.isContributor) && <IconButton onClick={() => navigate("/ootr/tricks/" + trick.id + "/edit")}><EditIcon /></IconButton>}</TableCell>
                                <TableCell style={{ fontSize: "1.3rem" }}>{trick.name}</TableCell>
                                <TableCell style={{ fontSize: "1.3rem" }}>{trick.description}</TableCell>
                                <TableCell>
                                    <Box display={"flex"} justifyContent="space-around" flexWrap={"wrap"}>
                                        {trick.links.map(l => {
                                            let isFavorite = userTricks.some(x => x.id === l.id);
                                            if (favoriteOnly && !isFavorite)
                                                return null;

                                            return <TrickLinkChip link={l} isFavorite={isFavorite} />
                                        })}
                                    </Box>
                                </TableCell>
                                <TableCell style={{ fontSize: "1.3rem" }}>{trick.location?.name}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table >
            </TableContainer>
        </Grid >
        <Grid item container xs={12} justifyContent={"center"}>
            <Typography fontSize={"1.3rem"}>
                Légende :
            </Typography>
            <Chip
                label="Basics"
                style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: getTrickDifficultyColor(1) }}
            />
            <Chip
                label="Beginner"
                style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: getTrickDifficultyColor(2) }}
            />
            <Chip
                label="Advanced"
                style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: getTrickDifficultyColor(3) }}
            />
            <Chip
                label="Expert"
                style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: getTrickDifficultyColor(4) }}
            />
            <Chip
                label="Black Magic"
                style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: getTrickDifficultyColor(5) }}
            />
        </Grid>
    </Grid >
}

export default OotTricksScreen;



interface TrickLinkChipProp {
    link: OotTrickLinkDto,
    isFavorite: boolean
}
const TrickLinkChip = (props: TrickLinkChipProp) => {

    let color = getTrickDifficultyColor(props.link.difficulty?.id);

    let context = useAppContext();

    let mutate = useMutationAddOrRemoveTrickToFavorite();




    return <Box component={"div"} className="trickChip" sx={{ backgroundColor: color }}>
        {context.isAuthenticated && props.isFavorite && <Button onClick={async () => await mutate.mutateAsync(props.link.id)}><HeartIcon sx={{ color: "pink" }} /></Button>}
        {context.isAuthenticated && !props.isFavorite && <Button onClick={async () => await mutate.mutateAsync(props.link.id)}><EmptyHeartIcon sx={{ color: "black" }} /></Button>}
        <Link href={props.link.url} target="_blank" >{props.link.name}</Link>
    </Box>

    // <Chip component={"a"}
    //         href={props.link.url}
    //         label={props.link.name}
    //         target="_blank"
    //         clickable
    //         style={{ fontSize: "1.3rem", margin: "2px", backgroundColor: color }}
    //     />
}